import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import type { TrackerPickerValue } from '@gpx-spa/ui';
import { useShipmentFormStore } from '@/stores/useShipmentFormStore';

export function useShipmentFormDeviceSelection() {
  const formStore = useShipmentFormStore();
  const { selectedDevices } = storeToRefs(formStore);

  const selectedDevicesPickerValue = computed<TrackerPickerValue[]>({
    get() {
      return selectedDevices.value.map((device) => ({
        value: device.id,
        label: device.label,
      }));
    },
    set(values) {
      formStore.setSelectedDevices(
        values.map((item) => ({ id: item.value, label: item.label })),
      );
    },
  });

  return {
    selectedDevicesPickerValue,
    selectedDevices,
  };
}
